var _circle, _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInsurance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F3EEFE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 14,
    width: 18,
    height: 20,
    rx: 1,
    stroke: "#8178C0",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 18h8",
    stroke: "#8178C0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 24.172v3.974a2 2 0 01-1.106 1.789L24 30.882l-1.894-.947A2 2 0 0121 28.145v-3.973c.428.013.96-.034 1.447-.278L24 23.118l1.553.776c.486.244 1.019.291 1.447.278z",
    stroke: "#8178C0",
    strokeWidth: 2
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjQiIGZpbGw9IiNGM0VFRkUiLz4KPHJlY3QgeD0iMTUiIHk9IjE0IiB3aWR0aD0iMTgiIGhlaWdodD0iMjAiIHJ4PSIxIiBzdHJva2U9IiM4MTc4QzAiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMjAgMThIMjgiIHN0cm9rZT0iIzgxNzhDMCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTI3IDI0LjE3MTVWMjguMTQ1OUMyNyAyOC45MDM0IDI2LjU3MiAyOS41OTYgMjUuODk0NCAyOS45MzQ4TDI0IDMwLjg4MkwyMi4xMDU2IDI5LjkzNDhDMjEuNDI4IDI5LjU5NiAyMSAyOC45MDM0IDIxIDI4LjE0NTlWMjQuMTcxNUMyMS40MjgyIDI0LjE4NTQgMjEuOTYwNSAyNC4xMzc4IDIyLjQ0NzIgMjMuODk0NEwyNCAyMy4xMThMMjUuNTUyOCAyMy44OTQ0QzI2LjAzOTUgMjQuMTM3OCAyNi41NzE4IDI0LjE4NTQgMjcgMjQuMTcxNVoiIHN0cm9rZT0iIzgxNzhDMCIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=";
export { SvgInsurance as ReactComponent };